import { boundMethod } from 'autobind-decorator';
import EventsHub from 'wootils/shared/eventsHub';
import ObjectUtils from 'wootils/shared/objectUtils';

class ProductFeedsJobsNotifications extends EventsHub {
  _storeKey = 'job-notifications';
  _jobs = [];
  /**
   * @param {AppErrorPublisher} appErrorPublisher To publish possible errors when loading accounts information.
   * @param {AppLocalStore}     appLocalStore     To store in browser local storage.
   * @param {AppSession}        appSession        To listen for session end.
   * @param {ProductFeedsJobs}  productFeedsJobs  To interact with Jobs.
   */
  constructor(appErrorPublisher, appLocalStore, appSession, productFeedsJobs) {
    'inject';

    super();

    this._appErrorPublisher = appErrorPublisher;
    this._appLocalStore = appLocalStore;
    this._productFeedsJobs = productFeedsJobs;

    appSession.onSessionEnd(this._cleanUp);

    this._eventNames = {
      visibilityChange: 'product-feeds-jobs-notifications/visibilityChange',
      jobsUpdated: 'product-feeds-jobs-notifications/jobsUpdate',
    };

    /**
     * The milliseconds to wait to `loadNotifications()` when the method is configured to recurse.
     * @type {number}
     * @access protected
     */
    this._refreshNotificationsWaitTime = 300000;

    this._loadInitialState();
  }
  dismiss() {
    this._jobs = [];
    this._appLocalStore.deleteKey(this._storeKey);
    this._setVisibility(false);
  }
  /**
   * Loads notifications; if `enablePolling` is set to true, then this method will poll for failed jobs every
   * `this._refreshNotificationsWaitTime` milliseconds.
   * @param {boolean} enablePolling Whether or not to refresh notifications.
   */
  loadNotifications(enablePolling = false) {
    this._productFeedsJobs.getFailedJobs()
    .then((jobs) => {
      if (jobs.length) {
        this._appLocalStore.setWithKey(this._storeKey, {
          jobs,
        });

        this._jobs = jobs;
        this._setVisibility(true);
      }
      if (enablePolling && this._refreshNotificationsWaitTime > 0) {
        setTimeout(() => {
          this.loadNotifications(true);
        }, this._refreshNotificationsWaitTime);
      }
    })
    .catch((error) => {
      this._appErrorPublisher.publish(error);
    });
  }
  on(event, fn) {
    return { dispose: super.on(event, fn) };
  }
  onJobsUpdate(fn) {
    return this.on(this._eventNames.jobsUpdated, fn);
  }
  onVisibilityChange(fn) {
    return this.on(this._eventNames.visibilityChange, fn);
  }
  showNotifications() {
    if (this._jobs.length) {
      this._setVisibility(true);
    }
  }
  @boundMethod
  _cleanUp() {
    this._appLocalStore.deleteKey(this._storeKey);
  }
  _loadInitialState() {
    const saved = this._appLocalStore.getFromKey(this._storeKey);
    if (saved) {
      this._jobs = saved.jobs;
    }
  }
  _setVisibility(visibility) {
    this.emit(
      this._eventNames.visibilityChange,
      visibility,
      ObjectUtils.copy(this._jobs),
    );
  }
}

export { ProductFeedsJobsNotifications };
